import { gql } from '@apollo/client';

import { RankingStudent, RankingItem } from '../../types';
import { rankingStudentFragment, rankingItemFragment } from '../fragments';

export interface GetAssignmentsRankingQueryVariables {
  courseId: string;
  queryParams: {
    startDate: string;
    endDate: string;
  };
}

export interface GetAssignmentsRankingQueryResult {
  assignmentRankingPayload: {
    courseId: string;
    courseName: string;
    students: RankingStudent[];
    assignments: RankingItem[];
  };
}

export const getAssignmentsRankingQuery = gql`
  query GetAssignmentsRankingQuery($courseId: String!, $queryParams: QueryParamsVariables!) {
    assignmentRankingPayload(courseId: $courseId, queryParams: $queryParams)
      @rest(
        type: "AssignmentsRankingPayload"
        path: "courses/{args.courseId}/leaderboard/assignments?startDate={args.queryParams.startDate}&endDate={args.queryParams.endDate}"
      ) {
      courseId
      courseName
      students @type(name: "RankingStudent") {
        ...RankingStudent
      }
      assignments @type(name: "RankingItem") {
        ...RankingItem
      }
    }
  }
  ${rankingStudentFragment}
  ${rankingItemFragment}
`;
